import * as $ from 'jquery';
import 'selectize';
import 'datepicker';
import 'bsfilestyle';
import 'MagnificPopup';
import * as moment from 'moment';
require('datatables.net');
require('datatablesResponsive');
require('parsley');
import * as Cookies from 'js-cookie';
require('parsley');
import { bookingFormCommon } from './c005-bookingform-common';


export class studentEnrollmentForm {
	private $loginError: Array<string> = [];
	$loginCookieName: string = 'MAB-Enrich-LoginID';

	private hideMobileIcon: boolean = false;
	private imageData: any = {type: 'file', data: null, name: null};
	private cameraView: any = 'front';
	private constraints: any = {
		video: {
		  width: 720,
		  height: 550,
		  facingMode: "user"
		},
	  };

	enrollmentForm(): any {
		let $studentSuccesContainer: any = $('.student-sucess-content');
		$studentSuccesContainer.hide();
		$('.ref_MHdiv').hide();
		$(".ref_mhexplor_id").on('click, focus', () => {
			$('.ref_MHdiv').show();
		});
		$(".ref_mhexplor_id").on('blur', (evt: any) => {
			if (evt.target.value == '') {
				$('.ref_MHdiv').hide();
			} else {
				$('.ref_MHdiv').show();
			}
		});
	}
	initFormTextInputs(): any {
		let _self: any = this;
		let $studentEnrollmentForm: any = $('#student-enrollment');
		let $enrichCookieEmail = _self.readValueFromCookie('studentEmail');
		let $enrichCookieName = _self.readValueFromCookie('studentName');
		let $isciEmail: any = $('.enrollment-isciEmail');
		let $enrichCookieDetails = "Hi " + $enrichCookieName;
		$isciEmail.text($enrichCookieDetails);
		$('#upload-idcard').attr('name', "upload-idcard");
		//$isciEmail.text($enrichCookieEmail); 
		let inputElArr = $studentEnrollmentForm.find('input[type="text"], input[type="email"],input[type="file"]');
		for (var i = 0, len = inputElArr.length; i < len; i++) {
			if (!inputElArr[i].classList.contains('datepicker')) { // exclude datepicker input fields
				$(inputElArr[i])
					.on('focus', function (e: any) {
						let $this: any = $(this);
						$this.addClass('input-focused').removeClass('has-error');
						$this.parent().addClass('input-focused');
						$this.parent().find('label').addClass('input-filled').removeClass('has-error');
					})
					.on('blur', function (e: any) {
						let $this: any = $(this);
						if ($this.val() == '') {
							$this.removeClass('input-focused');
							$this.parent().removeClass('input-focused');
							$this.parent().find('label').removeClass('input-filled');
						}
						else {
							$this.addClass('input-focused');
							$this.parent().find('label').addClass('input-filled');
						}
					});
			}
		}
	}
	initSelectizeInputs(): any {
		let _self = this;
		var infoSourceInput = $('#select-info-source');
		var getinfoSourceOptions = $.Deferred();
		let infoSourceurl: string = $('[data-info-source-url]').attr('data-info-source-url');
		var schoolLocationInput = $('#select-school-location');
		var getschoolLocations = $.Deferred();
		let schoolLocationurl: string = $('[data-school-location-url]').attr('data-school-location-url');

		if (infoSourceurl) {
			$.get(infoSourceurl)
				.done((data: any) => {
					var listItems = "<option value=''> </option>";
					if (typeof data === 'string') {
						data = JSON.parse(data);
					}

					for (var i = 0; i < data.infoSourceOptions.length; i++) {
						listItems += "<option value='" + data.infoSourceOptions[i].code + "'>" + data.infoSourceOptions[i].name + "</option>";
					}
					getinfoSourceOptions.resolve(listItems);
				})
				.fail((error: any) => {
					getinfoSourceOptions.reject(error);
				});
			$.when(getinfoSourceOptions).done(function (infoOptions: any) {
				infoSourceInput.html(infoOptions);
				_self.initInfoSourceSelectizeinputs(infoSourceInput);
			});
		}
		if (schoolLocationurl) {
			$.get(schoolLocationurl)
				.done((data: any) => {
					var listItems = "<option value=''> </option>";
					if (typeof data === 'string') {
						data = JSON.parse(data);
					}

					for (var i = 0; i < data.Countries.length; i++) {
						listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
					}
					getschoolLocations.resolve(listItems);
				})
				.fail((error: any) => {
					getschoolLocations.reject(error);
				});
			$.when(getschoolLocations).done(function (schoolLocations: any) {
				schoolLocationInput.html(schoolLocations);
				_self.initInfoSourceSelectizeinputs(schoolLocationInput);
			});
		}
	}
	initInfoSourceSelectizeinputs(inputSelect: any) {
		let _self = this;
		let $this: any = $(inputSelect);
		let $thisLabel: any = $this.parent().find('label');
		$this.selectize({
			valueField: 'value',
			labelField: 'text',
			searchField: ['text'],
			selectOnTab: true,
			onInitialize: () => {
				$this[0].selectize.$control_input.attr('name', $this[0].selectize.$input[0].id.split('--')[1]);
				$this[0].selectize.$control_input.attr('data-parsley-errors-container', '#' + $this[0].selectize.$input[0].id + '--error-container');
			},
			onFocus: () => {
				$thisLabel.addClass('input-filled');
				$($this[0].selectize.$control[0]).addClass('select-filled');

			},
			onChange: (value: any) => {
				$thisLabel.addClass('input-filled');
				$($this[0].selectize.$control[0]).addClass('select-filled');
			},
			onBlur: () => {
				let $activeOptionChange: any = $this[0].selectize.getValue();

				if ($activeOptionChange == null || !$activeOptionChange.length) {
					$thisLabel.removeClass('input-filled');
					$($this[0].selectize.$control[0]).removeClass('select-filled');
				} else {
					$thisLabel.addClass('input-filled');
					$($this[0].selectize.$control[0]).addClass('select-filled');
				}
			}

		});
	}
	initDatepickerInputs(): any {
		let _self = this;
		let $fields = [$('#study-end-date'),$("#study-enrollment-date")];
		let minDate = new Date();
		
		for(let i = 0; i<$fields.length; i++){
			let $label:any = $fields[i].parent().find('label');
			$fields[i].attr('readonly', 'readonly');
			minDate= $fields[i].attr("id")=="study-enrollment-date"? null:minDate;

			$fields[i].datepicker({
				showButtonPanel: true ,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				dateFormat: 'yy-mm-dd',
				numberOfMonths: 1,
				changeMonth: true,
				changeYear: true,
				yearRange: "-90:+90",
				minDate: minDate,
				onSelect : function(dateText:string, instance:any) {
					$fields[i].parent().addClass('input-focused');
					$fields[i].addClass('input-focused').removeClass('has-error');
					$label.addClass('input-filled').removeClass('has-error');
				},
				beforeShow: function( elm:any,instance:any ){
					instance.dpDiv.addClass("study-end-datepicker");
				}
			}
			);
		}

	}
	isLetter(str: any): any {
		return str.length === 1 && str.match(/[a-z]/i);
	}
	readValueFromCookie(name: string): any {
		var json = "";
		var ca = document.cookie.split(';');

		name = name + "=";

		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			};
		}
		return json;
	}
	enrollmentFormSubmit(): void {
		$('.student-enrollment-submit').click((evt: any) => {
			evt.preventDefault();
			let _self: any = this;
			let $studentEnrollmentForm: any = $('#student-enrollment');
			let form: any = $('#student-enrollment');
			let $loginPassword: any = $('.enrollment-isciNumber');
			let $loginErrorDiv: any = $('.login-error--validation');
			let $loginValidator: any = $('.login-validator');
			let $rememberMyEnrich: any = $('#login-remember--enrich');
			let $validationSuccess: any = true;
			let fileInputs: any = form.find('input[type="file"]');
			let $studentSuccesContainer: any = $('.student-sucess-content');
			let $studentEnrollmentComponent: any = $('.student-enrollment-component');

			_self.$loginError = [];
			let formData: Array<any> = [];
			$loginErrorDiv.show();
			$studentSuccesContainer.hide();
			$studentEnrollmentComponent.show()
			/* Sample code */
			let $uploadIdcard: any = $('.upload-idcard');
			let $uploadIdcard2: any = $('.upload-idcard2');
			let $uploadIdcardDiv: any = $uploadIdcard.parent().parent().find('.form-item');		
			let $isciNumber: any = $('.enrollment-isciNumber');
			let $isciEmail: any = $('.enrollment-isciEmail');
			let $studentType: any = $(".enrollment-student-type");
			let $studentTypeVal: any = $(".student-enrollment-component input[type='radio']:checked");
			let $enrollmentAgrement: any = $(".entrollment-agreement");
			let $enrollmentAgrementVal: any = $(".student-enrollment-component input[type='checkbox']:checked");
			let $MHExplorer_ID: any = $(".ref_mhexplor_id");
			let $infoSourceSelected: any = $('.select-info-source'),
			$infoSourceItem:any = $infoSourceSelected.parent().parent().find('.form-item');	
			let $schoolLocationSelected: any = $('.select-school-location'),
			$schoolLocationItem:any = $schoolLocationSelected.parent().parent().find('.form-item');			
			let $studyEndDate:any =$('#study-end-date');			
			let $studyEndDateItem:any = $studyEndDate.parent().parent().find('.form-item');			
			let $studyEnrollmentDate:any =$('#study-enrollment-date');			
			let $studyEnrollmentDateItem:any = $studyEnrollmentDate.parent().parent().find('.form-item');			

			let enrichId = _self.readValueFromCookie('student-enrichId');
			$('.enrichId').val(enrichId);
			// validate Student type
			// if ($studentTypeVal.val() == ''|| $studentTypeVal.val() == undefined){
			// 	let $studentTypeValidate:any = $studentType.attr('data-studentType');
			// 	_self.$loginError.push('<strong>'+$studentType.parent().find('label').text()+':</strong> '+$studentTypeValidate);
			// 	$studentType.addClass('has-error');
			// 	$studentType.parent().find('.booking-form--title').addClass('has-error');
			// 	$validationSuccess = false;
			// } else {
			// 	$studentType.removeClass('has-error');
			// 	$studentType.parent().find('.booking-form--title').removeClass('has-error');
			// }

			// validate ISCI Number
			if ($studentTypeVal.val() == 'isci-student') {

				if ($isciNumber.val() == '') {
					let $loginPasswordValidate: any = $loginPassword.attr('data-iscinumber');
					_self.$loginError.push('<strong>' + $loginPassword.parent().find('label').text() + ':</strong> ' + $loginPasswordValidate);
					$isciNumber.addClass('has-error');
					$isciNumber.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else {
					let isicValue = $isciNumber.val();
					let isicLength = isicValue.length;
					var str1 = isicValue.charAt(0);
					var str2 = isicValue.charAt(13);
					var f = _self.isLetter(str1);
					var l = _self.isLetter(str2);
					console.log("First letter=" + f + "  , last letter=" + l);
					if (isicLength != 14) {
						let $loginPasswordValidate: any = $loginPassword.attr('data-iscinumber');
						_self.$loginError.push('<strong>' + $loginPassword.parent().find('label').text() + ':</strong> ' + 'ISIC number should be 14 digit');
						$isciNumber.addClass('has-error');
						$isciNumber.parent().find('.booking-form--title').addClass('has-error');
						$validationSuccess = false;
					}
					else if (_self.isLetter(str1) == null || _self.isLetter(str2) == null) {
						let $loginPasswordValidate: any = $loginPassword.attr('data-iscinumber');
						_self.$loginError.push('<strong>' + $loginPassword.parent().find('label').text() + ':</strong> ' + 'ISIC number format is incorrect (First and last character should be alphabet)');
						$isciNumber.addClass('has-error');
						$isciNumber.parent().find('.booking-form--title').addClass('has-error');
						$validationSuccess = false;
					} else {

						$isciNumber.removeClass('has-error');
						$isciNumber.parent().find('.booking-form--title').removeClass('has-error');
					}

				}

			} else {
				if (fileInputs.val() == "" && _self.imageData.data==null) {
					let $uploadIdcardValidate: any = "This value is required";
					_self.$loginError.push('<strong>' + 'Upload id card' + ':</strong> ' + $uploadIdcardValidate);
					$uploadIdcard2.addClass('has-error');
					$uploadIdcard2.parent().find('.bootstrap-filestyle').addClass('has-error');
					$uploadIdcardDiv.addClass('has-error');
					$validationSuccess = false;
				}
				else {
					formData = form.find('input:not([id*="-selectized"]), select, textarea').serializeArray();
					var fileData: any;
					var fileName: any;
					let fileSize = 0;
					let fileExtension: any;
					var fileTypeSent: any;

					if(_self.imageData.data==null){

					if (fileInputs.length) {
						fileInputs.each(function () {
							let fileEl: any = $(this);
							if (fileEl[0].getAttribute('id') == "upload-idcard") {
								fileSize = (fileEl[0].files[0].size) / 1024 / 1024;
								fileName = fileEl[0].files[0].name;
								fileExtension = fileName.split('.').pop();
								fileExtension = fileExtension.toLowerCase();
								fileTypeSent = "DOCUMENT_UPLOADED"
							}
						});
					}
					
				}else{
					
					if(_self.imageData.type === "camera") {
						let base64 = _self.imageData.data.split(',')
						fileData = base64[1];
						fileSize = Math.round(fileData*(3/4)) / 1024 / 1024;
						fileName = _self.imageData.name;
						fileExtension = _self.imageData.name.split('.').pop();
						fileTypeSent = "IMAGE_CAPTURED"
					} 	
						
					}

					var extensions = ["jpg", "jpeg", "tiff", "png", "gif", "bmp", "pdf"];
					if (extensions.indexOf(fileExtension) < 0) {
						$uploadIdcard2.removeClass('has-error');
						$uploadIdcard2.parent().find('.bootstrap-filestyle').removeClass('has-error');
						let $uploadIdcardValidate: any = "Not a valid file type, please upload file in following format jpg, jpeg, tff, png, gif, bmp, pdf";
						_self.$loginError.push('<strong>' + 'Upload id card' + ':</strong> ' + $uploadIdcardValidate);
						$uploadIdcard2.removeClass('has-error');
						$uploadIdcard2.parent().find('.bootstrap-filestyle').removeClass('has-error');
						$uploadIdcardDiv.addClass('has-error');
						$validationSuccess = false;
					}
					else if (fileSize > 5) {
						$uploadIdcard2.removeClass('has-error');
						$uploadIdcard2.parent().find('.bootstrap-filestyle').removeClass('has-error');
						let $uploadIdcardValidate: any = "File Size shouldn't be greater than 5MB";
						_self.$loginError.push('<strong>' + 'Upload id card' + ':</strong> ' + $uploadIdcardValidate);
						$uploadIdcard2.removeClass('has-error');
						$uploadIdcard2.parent().find('.bootstrap-filestyle').removeClass('has-error');
						$uploadIdcardDiv.addClass('has-error');
						$validationSuccess = false;
					} else {
						$uploadIdcard2.removeClass('has-error');
						$uploadIdcard2.parent().find('.bootstrap-filestyle').removeClass('has-error');
						$uploadIdcardDiv.removeClass('has-error');
					}
					
				}
			}

			if ($enrollmentAgrementVal.val() == '' || $enrollmentAgrementVal.val() == undefined) {
				//let $enrollmentAgrementValidate:any = $enrollmentAgrement.attr('data-agreement');
				let $enrollmentAgrementValidate: any = "This value is required";
				_self.$loginError.push('<strong>' + 'Agreement' + ':</strong> ' + $enrollmentAgrementValidate);
				$enrollmentAgrement.addClass('has-error');
				$enrollmentAgrement.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$enrollmentAgrement.removeClass('has-error');
				$enrollmentAgrement.parent().find('.booking-form--title').removeClass('has-error');
			}
			if ($infoSourceSelected.length > 0) {
				if ($infoSourceSelected.val() == '') {
					let $infoSourceValidate: any = "This value is required";
					_self.$loginError.push('<strong>' + 'Information source' + ':</strong> ' + $infoSourceValidate);

					$infoSourceItem.addClass('has-error');
					$validationSuccess = false;
				} else {
					$infoSourceItem.removeClass('has-error');
				}
			}
			if ($schoolLocationSelected.length > 0) {
				if ($schoolLocationSelected.val() == '') {
					let $schoolLocationValidate: any = "This value is required";
					_self.$loginError.push('<strong>' + 'School/University Location' + ':</strong> ' + $schoolLocationValidate);

					$schoolLocationItem.addClass('has-error');
					$validationSuccess = false;
				} else {
					$schoolLocationItem.removeClass('has-error');
				}
			}
			if ($studyEnrollmentDate.length > 0) {
				if ($studyEnrollmentDate.val() == '') {
					let $studyEnrollmentDateValidate: any = "This value is required";
					_self.$loginError.push('<strong>' + 'Study End Date' + ':</strong> ' + $studyEnrollmentDateValidate);

					$studyEnrollmentDateItem.addClass('has-error');
					$validationSuccess = false;
				} else {
					$studyEnrollmentDateItem.removeClass('has-error');
				}
			}
			if ($studyEndDate.length > 0) {
				if ($studyEndDate.val() == '') {
					let $studyEndDateValidate: any = "This value is required";
					_self.$loginError.push('<strong>' + 'Study End Date' + ':</strong> ' + $studyEndDateValidate);

					$studyEndDateItem.addClass('has-error');
					$validationSuccess = false;
				} else {
					$studyEndDateItem.removeClass('has-error');
				}
			}
			if ($MHExplorer_ID.val() != "" && $MHExplorer_ID.val().replace(/\s+/g, '').length != 9) {
				let $MHExplorer_IDtValidate: any = "Referrer Enrich  ID should be 9 digits";
				_self.$loginError.push('<strong>' + 'Enrich ID' + ':</strong> ' + $MHExplorer_IDtValidate);
				$MHExplorer_ID.addClass('has-error');
				$MHExplorer_ID.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;
			}
			else {
				$MHExplorer_ID.removeClass('has-error');
				$MHExplorer_ID.parent().find('.booking-form--title').removeClass('has-error');
			}

			if ($MHExplorer_ID.val() != "" && $validationSuccess) {
				let $data = {
				}
				$data['MHExplorer_ID'] = $MHExplorer_ID.val();
				$.ajax({
					type: 'GET',
					async: false,					
					url: $('[data-get-mhe-ref-eligibility-details]').attr('data-get-mhe-ref-eligibility-details'),
					data: $data,
					success: function (msg: any) {
						let json: any = null;
						if (typeof msg === 'string') {
							json = JSON.parse(msg);
						} else {
							json = msg;
						}						
						if (json.success == 'false') {
							let $MHExplorer_IDtValidate: any = json.message;
							_self.$loginError.push('<strong>' + 'Enrich ID' + ':</strong> ' + $MHExplorer_IDtValidate);
							$MHExplorer_ID.addClass('has-error');
							$MHExplorer_ID.parent().find('.booking-form--title').addClass('has-error');
							$validationSuccess = false;
						}						
						else {
							$MHExplorer_ID.removeClass('has-error');
							$MHExplorer_ID.parent().find('.booking-form--title').removeClass('has-error');
						}


					},
					error: function (error: any) {
						$('.error-validation').find(".validation-content").html("Please try after some time");
					}
				});
			}

			let $validationContainer: any = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist: any = $validationContainer;

			for (var i = 0, len = this.$loginError.length; i < len; i++) {
				$validationMessagelist.append('<li data-id="' + i + '">' + this.$loginError[i] + '</li>');
			}

			if ($validationSuccess) {

				$loginErrorDiv.hide();

				let validation: any = $studentEnrollmentForm.parsley({
					errorClass: 'has-error',
					classHandler: function (el: any) {
						return el.$element.closest('.form-item');
					},
				});
				formData = form.find('input:not([id*="-selectized"]), select, textarea').serializeArray();


				if (fileInputs.length) {
					fileInputs.each(function () {
						let fileEl: any = $(this);
						formData.push({
							"name": fileEl[0].getAttribute('id'),
							"value": fileEl[0].files
						});
					});
				}
				let htmlFormData: any = new FormData(validation.$element[0]);
				let bcommon: any = new bookingFormCommon();

				var userid = _self.readValueFromCookie('student-enrichId');
				var studentDob = _self.readValueFromCookie('studentDob');
				let $submissionType: any = $(".mhexplorer-renew").val();
				formData.push({
					"name": "enrichId",
					"value": userid

				});
				let sourcId: string = '';
				let sourceName: string = '';
				if ($infoSourceSelected.length > 0) {
					sourcId = $infoSourceSelected.val();
					sourceName = $('.select-info-source option:selected').text();

				}
				formData.push({
					"sourceId": sourcId,
					"sourceName": sourceName
				});
				htmlFormData.append("sourceId", sourcId);
				htmlFormData.append("sourceName", sourceName);

				let studyLocation: string = '';				
				if ($schoolLocationSelected.length > 0) {
					studyLocation = $schoolLocationSelected.val();
				}
				formData.push({
					"studyLocation": studyLocation					
				});
				htmlFormData.append("studyLocation", studyLocation);

				let studyEnrollmentDate: string = '';				
				if ($studyEnrollmentDate.length > 0) {
					let sed = new Date($studyEnrollmentDate.val());
					studyEnrollmentDate = [sed.toString().slice(4,10), sed.getFullYear(), '12:00:00 AM'].join(", ");
				}
				formData.push({
					"studentStudyEnrolmentDate": studyEnrollmentDate				
				});
				htmlFormData.append("studentStudyEnrolmentDate", studyEnrollmentDate);

				let studyEndDate: string = '';				
				if ($studyEndDate.length > 0) {
					let sed = new Date($studyEndDate.val());
					studyEndDate = [sed.toString().slice(4,10), sed.getFullYear(), '12:00:00 AM'].join(", ");
				}
				formData.push({
					"studentStudyEndDate": studyEndDate				
				});
				htmlFormData.append("studentStudyEndDate", studyEndDate);	

				if (_self.imageData.data !== null) {
					htmlFormData.append("imageFileData", fileData);
					htmlFormData.append("imageFileName", fileName);
				}
				htmlFormData.append("fileTypeSent",fileTypeSent)
				if ($submissionType == 'renew') {
					bcommon.preloader();
					$.ajax({
						type: 'POST',
						url: '/bin/services/new/renewalNonIsicUser',
						data: htmlFormData,
						success: function (msg: any) {
							var json = JSON.parse(msg);
							var responseCode = json.code;
							var expires = "";
							var memberSinceCookie = moment(json.memberSince).format("YYYY-MM-DD");
							var expiryDateCookie = moment(json.expiryDate).format("YYYY-MM-DD");
							document.cookie = "studentId=" + json.studentId + ";" + expires + ";path=/";
							document.cookie = "studentExpiryDate=" + expiryDateCookie + ";" + expires + ";path=/";
							document.cookie = "studentMemberSince=" + memberSinceCookie + ";" + expires + ";path=/";
							if (responseCode == "RP") {
								//Succes message display
								$studentEnrollmentForm.hide();
								$studentSuccesContainer.show();
								$studentEnrollmentComponent.hide();

							}
							else {
								$loginErrorDiv.show();
								var errormsg = json.message;
								_self.$loginError.push(errormsg);

							}

							var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
							var $validationMessagelist = $validationContainer;

							for (var i = 0, len = _self.$loginError.length; i < len; i++) {
								$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
							}
							bcommon.preloaderClose();
						},
						error: function (error: any) {
							bcommon.preloaderClose();

						},
						cache: false,
						contentType: false,
						processData: false,
					});
				} else {
					if ($studentTypeVal.val() == 'isci-student') {
						bcommon.preloader();
						$.ajax({
							type: 'POST',
							url: '/bin/services/new/registerIsicUser',
							data: htmlFormData,
							success: function (msg: any) {
								var json = JSON.parse(msg);
								var responseCode = json.code;

								if (responseCode == "RS") {
									var registerSucess = $("#exceptionmsg1").attr("data-registerSuccess");
									bcommon.preloaderClose();
									window.location.href = registerSucess;
								}
								else if (responseCode == "VF") {
									$loginErrorDiv.show();
									_self.$loginError.push("ISIC verification failed. Please verify the data entered.");
								}
								else if (responseCode == "RE") {
									$loginErrorDiv.show();
									_self.$loginError.push("Error happened while registering profile with MH Student Portal.");
								}
								else if (responseCode == "RP") {
									$loginErrorDiv.show();
									_self.$loginError.push("Profile registration request is successfully submitted in MH Student Portal. Account will be active once admin approved the registration.");
								}
								else {
									$loginErrorDiv.show();
									var errormsg = responseCode.message;
									_self.$loginError.push(errormsg);

								}
								var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
								var $validationMessagelist = $validationContainer;

								for (var i = 0, len = _self.$loginError.length; i < len; i++) {
									$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
								}
								bcommon.preloaderClose();
							},
							error: function (error: any) {
								bcommon.preloaderClose();
							},
							cache: false,
							contentType: false,
							processData: false,
						});
					} else {
						bcommon.preloader();
						$.ajax({
							type: 'POST',
							url: '/bin/services/new/registerNonIsicUser',
							data: htmlFormData,
							success: function (msg: any) {
								var json = JSON.parse(msg);
								var responseCode = json.code;
								var expires = "";
								var memberSinceCookie = moment(json.memberSince).format("YYYY-MM-DD");
								var expiryDateCookie = moment(json.expiryDate).format("YYYY-MM-DD");
								document.cookie = "studentId=" + json.studentId + ";" + expires + ";path=/";
								document.cookie = "studentExpiryDate=" + expiryDateCookie + ";" + expires + ";path=/";
								document.cookie = "studentMemberSince=" + memberSinceCookie + ";" + expires + ";path=/";
								document.cookie = "enrichId=" + json.enrichId + ";" + expires + ";path=/";
								if (responseCode == "RP") {
									//Succes message display
									$studentEnrollmentForm.hide();
									$studentSuccesContainer.show();
									$studentEnrollmentComponent.hide();

								}
								else {
									$loginErrorDiv.show();
									var errormsg = json.message;
									_self.$loginError.push(errormsg);

								}

								var $validationContainer = $loginValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
								var $validationMessagelist = $validationContainer;

								for (var i = 0, len = _self.$loginError.length; i < len; i++) {
									$validationMessagelist.append('<li data-id="' + i + '">' + _self.$loginError[i] + '</li>');
								}
								bcommon.preloaderClose();
							},
							error: function (error: any) {
								bcommon.preloaderClose();

							},
							cache: false,
							contentType: false,
							processData: false,
						});
					}
				}
			}

		});
	}
	ratingFunctionality(): void {
		let _self: any = this;
		if ($('.mhe-rate input[name=rate]:radio').length > 0) {
			$('.mhe-rate input[name=rate]:radio').click(function () {
				if (parseInt($('.mhe-rate input[name=rate]:radio:checked').val()) < 4) {
					$('.student-sucess-content .rating-comments').removeClass('hide');
				}
				else {
					$('.student-sucess-content .rating-comments').addClass('hide');
				}
			});
		}
		$('.student-sucess-content #back-to-home').click(function () {
			let enrichId = _self.readValueFromCookie('student-enrichId');
			let rating: number = 0;
			rating = $('.mhe-rate input[name=rate]:radio:checked').val() ? parseInt($('.mhe-rate input[name=rate]:radio:checked').val()) : 0;
			let feedBack: any = ($('.student-sucess-content #comment--message').length > 0) ? $('.student-sucess-content #comment--message').val() : '';

			var $data: any = {
				enrichId: enrichId,
				rate: rating,
				feedBack: feedBack
			};
			$.ajax({
				type: 'POST',
				url: '/bin/services/new/explorerFeedBack',
				data: $data,
				success: function (msg: any) {
				},
				error: function (error: any) {
				}
			});
			window.location.href = $('[data-back-home-url]').attr('data-back-home-url');
		});
	}
	initializeManualAndCameraSettings(): any {
		let self = this;

		if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
		  self.hideMobileIcon = false;
		} else {
		  self.hideMobileIcon = true;
		}
		if(self.hideMobileIcon) {
		  $('.via-webcam').addClass('hideclass').removeClass('showclass');
		  $('.warning-text').addclass('showclass').removeClass('hideclass');
		}
		// end logic of hide mobile icon
		// reset camera images for manual upload files
		$('#upload-idcard').change(function() {

		  $('#file-chosen1').html('');
		  self.imageData.data = null;
		  self.imageData.type = 'file';

		  let image:any = document.getElementById("image-document1");
		  image.src = null;
		  image.classList.remove('showclass');
		  image.classList.add('hideclass');
		});
	  }									
	captureImagesInMobilesView() {
	let self = this;
	const captureVideoButton1: any = document.querySelector('.start-video1');
	//const captureDesktopVideoButton2: any = document.querySelector('.desktop-start-video1');
	let screenshotButton: any = null;
	let video: any = null;
	let img: any = null;
	let canvas: any = null;
	let elem: any = null;
	let image: any = null;
	let flipView: any = document.querySelector('.flip-camera');

	captureVideoButton1.onclick = function () {

	let elem:any;
		if(window.innerWidth<768){
		elem = document.getElementById('mobile-screenshot1');
		if($("#image-name").val() != null || $("#image-name").val() !== ""){
			$("#mob-image-name").val($("#image-name").val() );
		}
	}else{
		elem = document.getElementById('desktop-screenshot1');
		if($("#mob-image-name").val() != null || $("#mob-image-name").val() !== ""){
			$("#image-name").val($("#mob-image-name").val() );
		}
	}	
		$('.error-validate').html("");
		elem.classList.add('showclass');
		elem.classList.remove('hideclass');
		$(".media-error").addClass("hideclass").removeClass("showclass");
		
		let form: any = document.getElementById('student-enrollment');
		form.classList.add('hideclass');
		form.classList.remove('showclass');

		elem.classList.add('bounce-in-right');
		setTimeout(() => {
		elem.classList.remove('bounce-in-right');
		}, 1000)

		video = elem.querySelector("video");
		screenshotButton = elem.querySelector(".screenshot-button");
		canvas = document.createElement("canvas");
		image = document.getElementById("image-document1");

		//handle close
		$(elem).find("#close-screenshot i").click(function(){

			elem.classList.add('hideclass');
			elem.classList.remove('showclass');
			form.classList.add('showclass');
			form.classList.remove('hideclass');
			form.classList.add('bounce-in-right');
			$(".screenshot-button").removeClass("disabled");
			$(".media-error").addClass("hideclass").removeClass("showclass");
			// Stop video stream
			video.srcObject.getTracks()[0].stop();
			self.imageData.data = null;
			self.imageData.type = 'file';
  
			let image:any = document.getElementById("image-document1");
			image.src = null;
			image.classList.remove('showclass');
			image.classList.add('hideclass');
			setTimeout(() => {
				form.classList.remove('bounce-in-right');
			  }, 1000);
		  });
		

		screenshotButton.onclick = video.onclick = function () {
		
		//clear manual upload
		$('#upload-idcard').filestyle("clear");
				
		// Show error if name not provided
		if(window.innerWidth<768){
			
			if($("#mob-image-name").val() === null || $("#mob-image-name").val() === "") {
				
				$(".error-item").addClass("showclass");
				$(".error-item").removeClass("hideclass");
				return;
			}
			$(".error-item").addClass("hideclass");
			$(".error-item").removeClass("showclass");
		}else{
			if($("#image-name").val() === null || $("#image-name").val() === "") {
				$(".error-item").addClass("showclass");
				$(".error-item").removeClass("hideclass");
				return;
				}
				$(".error-item").addClass("hideclass");
				$(".error-item").removeClass("showclass");
		}
		
		// Click screenshot
		canvas.width = video.videoWidth;
		canvas.height = video.videoHeight;
		canvas.getContext("2d").drawImage(video, 0, 0);

		// Set preview image
		image.src = canvas.toDataURL("image/png"); // Other browsers will fall back to image/png
		image.classList.add('showclass');
		image.classList.remove('hideclass');
		
		// Stop video stream
		video.srcObject.getTracks()[0].stop();

		// Hide screenshot 
		elem.classList.add('hideclass');
		elem.classList.remove('showclass');

		// Show form
		form.classList.add('showclass');
		form.classList.remove('hideclass');
		form.classList.add('bounce-in-right');
		setTimeout(() => {
			form.classList.remove('bounce-in-right');
		}, 1000);

		// Set image data for form
		self.imageData.data = image.src;
		self.imageData.type = 'camera';

		let base64 = self.imageData.data.split(',')
		let imagetype = base64[0].split('/')[1].split(';')[0];

		if(window.innerWidth<768){
			self.imageData.name = $("#mob-image-name").val() + '.' + imagetype; 
			$(form).find('#file-chosen1').html(self.imageData.name);
		}else{
			self.imageData.name = $("#image-name").val() + '.' +imagetype; 
			$(form).find('#file-chosen1').html(self.imageData.name);
		}
		// self.imageData.file = self.dataURLtoFile(self.imageData.data, self.imageData.name, imagetype);
		};
		navigator.mediaDevices
		.getUserMedia(self.constraints)
		.then(handleSuccess)
		.catch(handleError);
		if(window.innerWidth<768){
		
		flipView.onclick = function() {
		video.srcObject.getTracks()[0].stop();
		self.cameraView = self.cameraView == "rear" ? "front" : "rear";
		if(self.cameraView == "rear") {
			self.constraints = {
			video: {
				width: 720,
				height: 550,
				facingMode: {
				exact: 'environment'
				}
			},
			}
		} else if(self.cameraView == "front") {
			self.constraints = {
			video: {
				width: 720,
				height: 550,
				facingMode: 'user',
			},
			}
		}
		navigator.mediaDevices
		.getUserMedia(self.constraints)
		.then(handleSuccess)
		.catch(handleError);
		}
		};

	};

	
	function handleSuccess(stream : any) {
		video.srcObject = stream;
	}
	function handleError(error : any) {
		console.error("Error: ", error);
		$(".media-error").addClass("showclass").removeClass("hideclass");
		$(".screenshot-button").addClass("disabled");
	}
	}

	dataURLtoFile(url: any, filename: any, mimeType: any):any{
        return (fetch(url)
            .then(function(res){return res.arrayBuffer();})
            .then(function(buf){return new File([buf], filename,{type:mimeType});})
        );
    }

}


let scope: Element = document.querySelector('.student-enrollment-component');
if (scope) {
	try {
		let $loginBtn = $(scope).find('button.student-enrollment');
		let loginform = new studentEnrollmentForm();
		loginform.enrollmentForm();
		loginform.initFormTextInputs();
		loginform.initSelectizeInputs();
		loginform.initDatepickerInputs();
		loginform.enrollmentFormSubmit();
		loginform.ratingFunctionality();
		loginform.initializeManualAndCameraSettings();
		loginform.captureImagesInMobilesView();

	} catch (e) { console.error(e); }
}